import React, { Component } from 'react';
import {api} from "../rest";
import swal from "sweetalert2";
import Loading from "./loading";

export default class FormBus extends Component {
	constructor() {
		super();
		this.state = {
			camion: "",
			modelo: "",
			fetching: false
		}
		this.handleFormSubmit = this.handleFormSubmit.bind(this);
		this.handleModelChange = this.handleModelChange.bind(this);
		this.handleBusChange = this.handleBusChange.bind(this);
	}
	handleFormSubmit (e) {
		e.preventDefault();
		this.setState({fetching: true});
		api.post(`/models/${this.state.modelo}/buses`,{name: this.state.camion})
		.then(()=>{
			swal("Contratante creado",this.state.camion,"success");
			this.setState({camion: "",modelo: ""});
		})
		.catch(({response: {status}})=>{
			if (status === 406) {
				swal("Error", `Ya existe un autobus con ese nombre`,"error");
			} else {
				swal("Error", `Status: ${status}`,"error");
			}
			console.log(error);
		})
		.then(()=>{
			this.setState({fetching: false});
		})
	}
	handleModelChange({target: {value}}) {
		this.setState({modelo: value});
	}
	handleBusChange({target: {value}}) {
		this.setState({camion: value});
	}
	render() {
		const models = this.props.data.map(({name,id},i)=><option key={i} value={id}>{name}</option>)
		return (
			<form className="group columns small-12" onSubmit={this.handleFormSubmit}>
				<Loading loading={this.state.fetching}/>
				<div className="group-title">Crear nuevo autobus</div>
				<div className="row">
					<label className="columns small-4">
						<em>Modelo</em>
						<select value={this.state.modelo} onChange={this.handleModelChange} required autoFocus>
							<option disabled value=""> --- Selectiona --- </option>
							{models}
						</select>
					</label>
					<label className="columns small-4">
						<em>Autobus</em>
						<input type="text" value={this.state.camion} onChange={this.handleBusChange} required/>
					</label>
					<label className="columns small-4">
						<em> </em>
						<button type="submit" className="button success expanded" disabled={this.state.fetching}>Guardar</button>
					</label>
				</div>
			</form>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/components/form_bus.js
 **/